import type { BlockStackProps } from '@shopify/polaris';

import { BlockStack } from '@shopify/polaris';
export interface GBlockStackProps extends BlockStackProps {
  height?: string;
  minHeight?: string;
  width?: string;
}

export const GBlockStack = (props: GBlockStackProps) => {
  const style = {
    '--gp-block-stack-height': props.height,
    '--gp-block-stack-min-height': props.minHeight,
    '--gp-block-stack-width': props.width,
  } as React.CSSProperties;

  return (
    <div className="Polaris-GBlockStack" style={style}>
      <BlockStack {...props} />
    </div>
  );
};

const Cell = (props: GBlockStackProps) => {
  const style = {
    '--gp-block-stack-height': props.height,
    '--gp-block-stack-min-height': props.minHeight,
    '--gp-block-stack-width': props.width,
  } as React.CSSProperties;

  return (
    <div className="Polaris-GBlockStack-Cell" style={style}>
      {props.children}
    </div>
  );
};

GBlockStack.Cell = Cell;
